export default __webpack_public_path__ + "static/media/Footer.37d41ba7.png";